// recon-supplier-messages translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'rcu.flag.old': 'Partida de más de 90 días',
  'rcu.flag.overdue30': 'Vencida hace más de 30 días',
  'rcu.flag.negative': 'Saldo de proveedor negativo',
  'rcu.flag.duplicate': 'Posible duplicado',
  'rcu.flag.partlyPaidOpen': 'Pagada parcialmente, aún abierta',
  'rcu.flag.currency': 'Hay que revisar el tipo de cambio',
  'rcu.flag.missingDoc': 'Falta el justificante',
  'rcu.flag.paidAfter': 'Pagada después de la fecha del periodo',
  'rcu.age.noDue': 'Sin fecha de vencimiento',
  'rcu.age.notDue': 'No vencida',
  'rcu.age.d1to30': '1–30 días de retraso',
  'rcu.age.d31to60': '31–60 días de retraso',
  'rcu.age.d61to90': '61–90 días de retraso',
  'rcu.age.over90': 'Más de 90 días de retraso',
  'rcu.type.overpayment': 'Pago en exceso',
  'rcu.type.invoice': 'Factura',
  'rcu.unknownSupplier': 'Proveedor desconocido',
  'rcu.type.supplierCredit': 'Crédito de proveedor',
  'rcu.type.importedInvoice': 'Factura importada',
  'rcu.importedItem': 'Partida importada',
  'rcu.check.ledgerVsSubledger': 'Libro mayor frente al auxiliar',
  'rcu.check.noControlAccount': 'Ninguna cuenta de control con auxiliar en el área',
  'rcu.check.old': 'Partidas de más de 90 días',
  'rcu.check.overdue30': 'Partidas vencidas hace más de 30 días',
  'rcu.check.negative': 'Saldos de proveedor negativos',
  'rcu.check.duplicates': 'Posibles duplicados',
  'rcu.check.paymentsNoInvoice': 'Pagos sin factura',
  'rcu.check.partlyPaidOpen': 'Pagadas parcialmente pero aún abiertas',
  'rcu.check.currencyItems': 'Partidas en moneda extranjera por revisar',
  'rcu.check.directPostings': 'Asientos directos en la cuenta de control',
  'rcu.check.missingDocs': 'Justificantes que faltan',
});
